const alphabetically = new Intl.Collator('en', { sensitivity: 'base', numeric: true });

/** Sort a copy without changing ward names or the participant's selected value. */
export function sortWardNames(names: readonly string[] | undefined): string[] {
  return [...(names ?? [])].sort(alphabetically.compare);
}
